import React from "react";
import { Link } from "react-router-dom";
import { newReleases } from "../../musicPageData";

export default function NewReleases() {
  return (
    <section className="mu-section pb-0">
      <div className="container">
        <div className="mu-eyebrow">Just Dropped</div>
        <h2 className="section-title mb-4">New Releases</h2>

        <div className="release-scroll">
          {newReleases.map((r) => (
            <Link to={`/music/${r.slug}`} className="release-card" key={r.id}>
              <div className="release-art">
                <img src={r.img} alt={r.title} />
                <span className="track-genre-badge">{r.genre}</span>
              </div>
              <div className="track-info">
                <div className="track-title">{r.title}</div>
                <div className="track-meta">{r.artist}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
